import React, { useState } from "react";
import { Text, Pressable, View, ActivityIndicator } from "react-native";

interface ButtonSmallProps {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export default function ButtonSmall(props: ButtonSmallProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (!props.disabled) {
      props.onClick();
    }
  };

  return (
    <View className="w-40 h-9 items-center justify-center">
      {props.isLoading ? (
        <ActivityIndicator size="large" color="#5D0CBA" />
      ) : (
        <Pressable
          className={`transition-colors delay-100 bg-purple1 hover:bg-purple3 items-center justify-center w-40 h-9 rounded ${
            props.disabled ? "bg-midgray" : ""
          }`}
          onPress={handleClick}
          onHoverIn={() => setIsHovered(true)}
          onHoverOut={() => setIsHovered(false)}
          disabled={props.disabled}
        >
          <Text className="text-white text-center">{props.label}</Text>
        </Pressable>
      )}
    </View>
  );
}
